import React from 'react'
import styles from './componentsStyles/Nav.module.css';
import {NavLink} from 'react-router-dom'
import {GiHamburgerMenu} from 'react-icons/gi'

const Nav = () => {
  return (
    <div className={styles.nav}>

        <input type="checkbox" id="mobcb" className={styles.mobCb} />
       
        <div className={styles.mobileIcon}>
            <label htmlFor="mobcb">
              <GiHamburgerMenu className={styles.icon}/>
            </label>
        </div>

        <div className={styles.logo}>
          <div className={styles.logoContainer}>
            <img src="./images/black-ice2.jpg" alt="black-ice" className={styles.img} />
          </div>
        </div>

      
        <div className={styles.navContainer}>

          <div>
            <div className={styles.navigation}>
                <NavLink to ='/'> <p> Home </p>           </NavLink>
                <NavLink to ='/docs'> <p> Docs </p> </NavLink>
                <NavLink to ='/about'> <p> About  </p>    </NavLink>
            </div>
          </div>
        </div>

    </div>
  )
}

export default Nav